import { IListElementCellBase } from './list-element-cell-base.interface';
import { IListElementCell } from './list-element-cell.interface';

import { IFormButton } from '../../form-button.interface';

export interface IListElementButtonCell extends IListElementCellBase {
  button: IFormButton | IFormButton[];
}

/**
 * Check cell on button type
 *
 * @param cell
 */
export function isButtonCell(
  cell: IListElementCell,
): cell is IListElementButtonCell {
  return 'button' in cell;
}
